import React from "react";
import Fade from "@material-ui/core/Fade";
import { makeStyles, Tooltip } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: 12,
    padding: "4px 14px",
    minWidth: 54,
    minHeight: 24,
    borderRadius: 4,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    color: "#ffffff",
    margin: "3px 0",
  },
  arrow: {
    fontSize: 8,
    color: "rgba(0, 0, 0, 0.7)",
  },
  wrapper: {
    display: "inline-block",
  },
}));

function WeduTooltip({ title, children, ...rest }) {
  const classes = useStyles();

  return (
    <>
      {title ? (
        <Tooltip
          placement="top"
          title={title}
          classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
          TransitionComponent={Fade}
          TransitionProps={{ timeout: 200 }}
          enterDelay={200}
          arrow
          {...rest}
        >
          <div className={classes.wrapper}>{children}</div>
        </Tooltip>
      ) : (
        children
      )}
    </>
  );
}

export default WeduTooltip;
